import { FiInbox } from "react-icons/fi";
import { TCustomerData, TDeviceData, TInstallment } from "../../types/types";
import { initialDeviceData } from "../../utils/constants";
import CustomerDeviceBox from "./CustomerDeviceBox";
import { Collapse } from "antd";
import moment from "moment";

const mock = [1, 2, 3, 4, 5];
const CustomerDevicesSection = ({
  customerData,
  data,
  isLoading,
}: {
  customerData: TCustomerData;
  data: TDeviceData[] | undefined;
  isLoading: boolean;
}) => {
  const collapseData = data?.map((device: TDeviceData, ind) => {
    const plan = device?.activePaymentPlan
      ? device.activePaymentPlan
      : device.paymentPlan;

    return {
      key: ind.toString(),
      label: (
        <CustomerDeviceBox
          key={ind}
          isLoading={isLoading}
          allDevices={data}
          data={device}
          customerData={customerData}
        />
      ),
      children: (
        <div>
          <div className="flex flex-row justify-between">
            <p className="mb-3">Payment instalments</p>
            <p className="text-[13px]">
              Last Activation:{" "}
              {device.lastActivationDate
                ? moment(device?.lastActivationDate).startOf("day").fromNow()
                : "N/A"}
            </p>
          </div>
          <div className="flex flex-row flex-wrap gap-1">
            {plan.paymentInstalments?.map((entry: TInstallment) => {
              return (
                <div className="flex items-center justify-between w-fit gap-3 border-[1px] border-[#D1D5DB] px-[7px] py-[3px] rounded-md">
                  <div>${entry.activationAmount}</div>
                  <div>{entry.activationDays} days</div>
                </div>
              );
            })}
          </div>
        </div>
      ),
      showArrow: false,
    };
  });

  return (
    <div className="customerDevices flex flex-col gap-[14px] pb-10">
      {isLoading ? (
        mock.map((datum, index) => {
          return (
            <CustomerDeviceBox
              key={index}
              isLoading={true}
              data={initialDeviceData}
              allDevices={[]}
              customerData={customerData}
            />
          );
        })
      ) : data && data?.length > 0 ? (
        <Collapse
          items={collapseData}
          accordion
          bordered={false}
          size="small"
        />
      ) : (
        <div className="w-full max-lg:h-[300px] lg:h-[200px] flex items-center justify-center">
          <div className="flex flex-col items-center justify-center gap-2">
            <FiInbox className="text-[#dddddd] text-[35px] " />
            <p className="Nunito text-[#dddddd] font-[400] text-[14px] ">
              No Devices
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerDevicesSection;
